import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import store from '@/store/store';

Vue.use(Vuetify);

export default new Vuetify({
  dark: false,
  icons: {
    iconfont: 'fa',
  },
  theme:{
    themes: {
      // dark: {
      //   primary: store.getters.getLoggedInUserSelectedBusinessBrandingPrimary,
      //   secondary: store.getters.getLoggedInUserSelectedBusinessBrandingSecondary,
      //   accent: store.getters.getLoggedInUserSelectedBusinessBrandingAccent,
      //   error: '#D0021B',
      //   warning: '#FFC200',
      //   info: '#666666',
      //   success: '#5CB85C',
      //   black: '#000000',
      //   bloodred: '#af371f',
      //   lightGrey: '#D8D8D8',
      //   darkGrey: '#4B4B4B',
      // },
      light: {
        primary: store.getters.getLoggedInUserSelectedBusinessBrandingPrimary,
        secondary: store.getters.getLoggedInUserSelectedBusinessBrandingSecondary,
        accent: store.getters.getLoggedInUserSelectedBusinessBrandingAccent,
        error: '#D0021B',
        warning: '#FFC200',
        info: '#666666',
        success: '#5CB85C',
        black: '#000000',
        bloodred: '#af371f',
        lightGrey: '#D8D8D8',
        darkGrey: '#4B4B4B',
      }
    },
  },
});
